(() => {
  const context = window.GOAT_ANALYTICS_CONTEXT || {};
  const dataLayer = window.dataLayer = window.dataLayer || [];
  const sent = new Set();

  const push = (event, payload = {}, onceKey = '') => {
    if (onceKey && sent.has(onceKey)) return;
    if (onceKey) sent.add(onceKey);
    const eventPayload = { goat_event_source: 'goat_storefront', ...payload };
    dataLayer.push({ event, ...eventPayload });

    if (event.startsWith('goat_') && window.Shopify?.analytics?.publish) {
      window.Shopify.analytics
        .publish(`goat:${event.slice(5)}`, eventPayload)
        .catch(() => {});
    }
  };

  const ecommerce = (event, extra = {}) => {
    if (!context.product) return;
    dataLayer.push({ ecommerce: null });
    push(event, {
      ecommerce: {
        currency: context.currency,
        value: context.product.price,
        items: [context.product],
        ...extra
      }
    }, event === 'view_item' ? 'view_item' : '');
  };

  if (context.page_type === 'product' && context.product) ecommerce('view_item');

  document.addEventListener('click', (event) => {
    const target = event.target.closest('button, a');
    if (!target) return;

    if (target.matches('button[id^="tryon-btn-"]')) {
      push('goat_try_on_open', { item: context.product || null });
    }

    const href = target instanceof HTMLAnchorElement ? target.href : '';
    if (href.includes('api.whatsapp.com') || href.includes('wa.me')) {
      push('goat_whatsapp_click', {
        page_type: context.page_type,
        item: context.product || null
      });
    }

    if (href.includes('#goat-bespoke')) {
      push('goat_design_studio_open', { page_type: context.page_type });
    }

    if (target.textContent.trim() === 'Buy Now' || href.includes('/checkout')) {
      ecommerce('begin_checkout');
    }
  }, true);

  document.addEventListener('change', (event) => {
    const input = event.target;
    if (!(input instanceof HTMLInputElement) || input.type !== 'file' || !input.files?.length) return;

    if (input.closest('.tryon-widget')) {
      push('goat_try_on_photo_selected', {
        file_type: input.files[0].type || 'unknown',
        item: context.product || null
      });
    } else if (input.closest('[data-goat-studio]')) {
      push('goat_design_studio_photo_selected', { field_name: input.name || 'studio_upload' });
    }
  }, true);

  document.addEventListener('submit', (event) => {
    const form = event.target;
    if (!(form instanceof HTMLFormElement)) return;

    if ((form.action || '').includes('/cart/add')) ecommerce('add_to_cart');
    if (form.closest('[data-goat-studio]')) push('generate_lead', { lead_type: 'private_design_brief' });
    if (form.closest('.goat-footer__newsletter')) push('sign_up', { method: 'footer_private_edit' });
  }, true);

  const observeTryOn = () => {
    const observer = new MutationObserver(() => {
      if (document.querySelector('.tryon-widget--open')) {
        push('goat_try_on_widget_view', { item: context.product || null }, 'try_on_widget_view');
      }
      if (document.querySelector('.tryon-result, .tryon-result-screen, [class*="tryon-result"]')) {
        push('goat_try_on_result_view', { item: context.product || null }, 'try_on_result_view');
      }
    });
    observer.observe(document.body, { childList: true, subtree: true, attributes: true, attributeFilter: ['class'] });
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', observeTryOn, { once: true });
  else observeTryOn();
})();
